import { render, staticRenderFns } from "./DashboardMessage.vue?vue&type=template&id=2468a468&scoped=true&"
import script from "./DashboardMessage.vue?vue&type=script&lang=js&"
export * from "./DashboardMessage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMessage.vue?vue&type=style&index=0&id=2468a468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468a468",
  null
  
)

export default component.exports